(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReadMore(section) {
    // Log the section being initialized
    console.log('Initializing Read More for section:', section.dataset.sectionId);

    const readMoreButton = section.querySelector('.read-more-button');
    const accordion = document.querySelector(`.iwt-text-2.accordion[data-section-id="${section.dataset.sectionId}"]`);

    if (readMoreButton && accordion) {
      console.log('Found Read More button and accordion for section:', section.dataset.sectionId);

      // Ensure no duplicate listeners
      readMoreButton.removeEventListener('click', toggleAccordion);

      // Add the toggle logic
      readMoreButton.addEventListener('click', toggleAccordion);

      function toggleAccordion() {
        const isHidden = accordion.style.display === 'none' || accordion.style.display === '';
        accordion.style.display = isHidden ? 'block' : 'none';

        // Log the toggle action
        console.log('Toggled accordion display to:', accordion.style.display);
      }

      // Ensure the accordion starts hidden
      accordion.style.display = 'none';
    } else {
      console.warn('Read More button or accordion not found for section:', section.dataset.sectionId);
    }
  }

  function unloadReadMore(section) {
    const readMoreButton = section.querySelector('.read-more-button');
    if (readMoreButton) {
      readMoreButton.removeEventListener('click', toggleAccordion);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    console.log('DOMContentLoaded triggered');
    const sections = document.querySelectorAll('[data-section-type="image-with-text"]');
    sections.forEach(initReadMore);
  });

  document.addEventListener('shopify:section:load', function (event) {
    console.log('shopify:section:load triggered');
    const section = event.target.querySelector('[data-section-type="image-with-text"]');
    if (section) {
      initReadMore(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    console.log('shopify:section:unload triggered');
    const section = event.target.querySelector('[data-section-type="image-with-text"]');
    if (section) {
      unloadReadMore(section);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
